import React /* , { Suspense } */ from 'react';
import { HashRouter } from 'react-router-dom';

import Navbar from "./components/Navbar";
import { AuthProvider } from "./contexts/AuthContext";
import './sass/style.sass'

import Rotas from './routes';

const App = () => {
  return (
    <AuthProvider>
      <HashRouter>
        {/* <Suspense fallback={""}> */}
        <div className="d-flex c-default-layout">
          <div className="c-wrapper">
            <Navbar />
            <div className="c-body">
              {Rotas()}
            </div>
          </div>
        </div>
        {/* </Suspense> */}
      </HashRouter>
    </AuthProvider>
  );
};

export default App;